export const labels = {
	copySpreadsNotification: {
		label: "Label.MobileCreator.Notification.CopySpreads",
		default: "Spread copied",
	},
} as const;
